import IndividualFileCollectionPage from './individualFileCollection.page';

export default IndividualFileCollectionPage;
